module.exports = __webpack_public_path__ + "img/rule_bet.45546054.png";